import assetDepartmentService from "../../../../services/assetService/assetDepartmentService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_ASSETDEPARTMENTS } from "../../../../utils/constants";
import { AssetDepartmentInterface } from "../../../../models/AssetModel/AssetDepartment";

const useAssetDepartments = (page: number, pageSize: number) =>
  useQuery<AssetDepartmentInterface[], Error>({
    queryKey: [
      CACHE_KEY_ASSETDEPARTMENTS,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
    ],
    queryFn: () => assetDepartmentService.GetAll(page, pageSize),
    initialData: [],
  });

export default useAssetDepartments;
